angular.module('ApptBookApp').controller('AppointmentBookStepsController', [
    '$scope',
    'appointmentBookModalService',
    'currentDetail',
    'currentAppointment',
    'AppointmentEditorService',
    'isReadOnly',
    'isFromBook',
    '$timeout',
    '$translate',
    'meevo.plugins.appointmentBook.stepOverrideService',
    (
        $scope,
        modal,
        currentDetail,
        currentAppointment,
        appointmentEditorService,
        isReadOnly,
        isFromBook,
        $timeout: angular.ITimeoutService,
        $translate: angular.translate.ITranslateService,
        stepOverrideService
    ) => {

        stepOverrideService.initialize(currentDetail, currentDetail.client).then(() => {
            $scope.steps = currentDetail.steps;
        });
        $scope.currentDetail = currentDetail;
        $scope.currentAppointment = currentAppointment;
        $scope.isReadOnly = isReadOnly;
        $scope.isFromBook = isFromBook;
        
        if ($scope.isFromBook) {
            appointmentEditorService.loadServiceCheckboxes(currentDetail);
            $scope.isRequested = currentDetail.isRequested;
            $scope.isWalkin = currentDetail.isWalkin;
            $scope.isRedo = currentDetail.isRedo;
        }

        $scope.stepDurationDisabled = () => {
            if (!$scope.currentDetail) {
                return true;
            }

            return $scope.currentDetail.doNotAllowStepTimingOverride;
        }

        $scope.stepDurationChanged = step => {
            $timeout(() => {
                $scope.currentDetail.totalMinutes = 0;
                $scope.currentDetail.steps.forEach(step => {
                    if (step.stateEnum !== Meevo.Model.StateEnum.Delete) {
                        $scope.currentDetail.totalMinutes += step.durationInMinutes + step.extendedByStepMinutes;
                    }
                });
                setState($scope.currentDetail, Meevo.Model.StateEnum.Edit);

                if ($scope.currentDetail.finalState === Meevo.Model.AppointFinalStateEnum.None) {
                    //Make all appointments later than appointment being edited contiguous to appointment being edited       
                    let nextStartTime = moment($scope.currentDetail.startTime);
                    var cleanupStepDuration = appointmentEditorService.getCleanupStepDuration($scope.currentDetail);
                    nextStartTime.add($scope.currentDetail.totalMinutes - cleanupStepDuration, 'm');

                    let orderedAppointmentServices = _.chain($scope.currentAppointment.services)
                        .filter(appointmentService => 
                            appointmentService.clientType == $scope.currentDetail.clientType &&
                            appointmentService.client.id == $scope.currentDetail.client.id &&
                            moment(appointmentService.startTime).isAfter(moment($scope.currentDetail.startTime))
                        )
                        .sortBy('startTime')
                        .value();

                    if (orderedAppointmentServices.length > 0) {
                        let clientDisplayName = appointmentEditorService.getAnonymousClientName(
                            $scope.currentAppointment.payingClient.clientType,
                            $scope.currentAppointment.payingClient.displayName
                        );
                        
                        const message = $translate.instant('MESSAGE_STEP_UPDATE_CONFIRM', { clientDisplayName: clientDisplayName });

                        modal.showMessage(message, { 
                            buttonsType: Meevo.Model.ButtonTypeEnum.YesNo,
                            callback: (result) => {
                                if (result === Meevo.Model.MessageBoxButtonResult.Yes) {
                                    let nextStartTime = moment($scope.currentDetail.startTime);
                                    var cleanupStepDuration = appointmentEditorService.getCleanupStepDuration($scope.currentDetail);
                                    nextStartTime.add($scope.currentDetail.totalMinutes - cleanupStepDuration, 'm');

                                    orderedAppointmentServices.forEach((appointmentService: any) => {
                                        appointmentService.startTime = nextStartTime.format();
                                        setState(appointmentService, Meevo.Model.StateEnum.Edit);
                                        
                                        cleanupStepDuration = appointmentEditorService.getCleanupStepDuration(appointmentService);

                                        nextStartTime.add(appointmentService.totalMinutes - cleanupStepDuration, 'm');
                                    })
                                }
                                appointmentEditorService.checkIfUpdateResources($scope.currentDetail);
                            }
                        });
                    } else {
                        appointmentEditorService.checkIfUpdateResources($scope.currentDetail);
                    }
                }

                setState(step, Meevo.Model.StateEnum.Edit);
            });
        }

        function setState(obj, newState) {
            if (newState === Meevo.Model.StateEnum.Edit && obj.stateEnum === Meevo.Model.StateEnum.Read) {
                obj.stateEnum = newState;
            }
        }

        $scope.closeModal = () => {
            modal.hideModal('close');
        }

        $scope.saveModal = () => {
            modal.hideModal().then(() => {
                if ($scope.isFromBook) {
                    currentDetail.isRequested = $scope.isRequested;
                    currentDetail.isWalkin = $scope.isWalkin;
                    currentDetail.isRedo = $scope.isRedo;
                    appointmentEditorService.saveServiceCheckboxes(currentDetail);
                }

                stepOverrideService.check(currentDetail, currentDetail.client);
            });
        }
    }
]);